import React, { ReactNode } from 'react';

import { DEQ_TYPES } from './deq.constants';

export interface DeqAnchorLinkProps {
  children: ReactNode;
  href?: string;
  title?: string;
  target?: string;
  deqComponentType: string;
  deqActionType?: string;
}

const DeqAnchorLink = ({
  children,
  href,
  title,
  target,
  deqComponentType,
  deqActionType,
}: DeqAnchorLinkProps) => (
  <a
    data-testid="anchor-link"
    href={href}
    data-element-label={(title || `${children}`).toLowerCase()}
    data-element-target={href}
    data-element-type={DEQ_TYPES.textLink}
    data-element-action={deqActionType || undefined}
    data-component-type={deqComponentType}
    target={target}
    rel="noreferrer"
  >
    {children}
  </a>
);

export default DeqAnchorLink;
